import { render, staticRenderFns } from "./LeaveDetail.vue?vue&type=template&id=4afe91e0"
import script from "../../controllers/leave/leave-detail.js?vue&type=script&lang=js&external"
export * from "../../controllers/leave/leave-detail.js?vue&type=script&lang=js&external"
import style0 from "./LeaveDetail.vue?vue&type=style&index=0&id=4afe91e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports